<template>
  <div class="Home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <HomeFrame />
  </div>
</template>

<script>

import HomeFrame from '@/components/HomeFrame.vue'

export default {
  name: 'Home',
    components: {
      HomeFrame
    }
}
</script>

<style>

</style>